import { render, staticRenderFns } from "./Virtuais.vue?vue&type=template&id=51d6c427"
import script from "./Virtuais.vue?vue&type=script&lang=js"
export * from "./Virtuais.vue?vue&type=script&lang=js"
import style0 from "./Virtuais.vue?vue&type=style&index=0&id=51d6c427&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports